import Glide from '@glidejs/glide';

let glide = new Glide('.glide-endorsements', {
  type: 'carousel',
  perView: 5,
  autoplay: 5000,
  breakpoints: {
    1024: {
      perView: 3
    },
    400: {
      perView: 1,
      autoplay: false
    }
  }
});
glide.mount();